import Vue from "vue";
import VueRouter from "vue-router";
import M from "@/libs/mapping.js";
import { MileageSalesService } from "./mileage-sales-service.js";
import SetStoreInfo from "@/libs/setting-store.js";

Vue.use(VueRouter);

let path = M.urlPath();

const routes = MileageSalesService;
const router = new VueRouter({
  mode: "history",
  routes,
});

/**
 * store 정보 세팅
 */
new SetStoreInfo(router, path);

export default router;
